/* eslint-disable no-shadow */
import {
  ADD_DISMISSED_BANNER,
  ADD_DISMISSED_DOC_UPLOAD_BANNER,
  BIOMETRIC_LOGIN_REQUEST,
  BIOMETRIC_LOGIN_REQUEST_FAILURE,
  CANCEL_BIOMETRIC_AUTHENTICATION,
  CANCEL_CHANGE_SELECTED_LOAN,
  CANCEL_CHANGE_SELECTED_LOAN_SUCCESS,
  CANCEL_LOGIN,
  CHANGE_SELECTED_LOAN,
  CHANGE_SELECTED_LOAN_FAILURE,
  CHANGE_SELECTED_LOAN_SUCCESS,
  CLOSE_MODAL,
  CONSENT_REQUEST,
  CONSENT_REQUEST_FAILURE,
  CONSENT_REQUEST_SUCCESS,
  DISABLE_INSTANT_POST_LOGIN_MODAL,
  DISABLE_MODAL,
  DISMISS_UPDATE_MODAL,
  DISPLAY_CHATBOT_ERROR_BANNER,
  FETCH_OIDC_CONFIG,
  FETCH_OIDC_CONFIG_FAILURE,
  FETCH_RESPA_LETTER,
  FETCH_RESPA_LETTER_FAILURE,
  FETCH_TRANSFER_STATUS,
  FETCH_TRANSFER_STATUS_FAILURE,
  FETCH_TRANSFER_STATUS_SUCCESS,
  INITIALIZE_OIDC_LOGIN,
  INITIALIZE_OIDC_LOGIN_CANCELLED,
  INITIALIZE_OIDC_LOGIN_FAILURE,
  INITIALIZE_REQUEST,
  INITIALIZE_REQUEST_FAILURE,
  INITIALIZE_REQUEST_SUCCESS,
  LINK_NATIVE_CLIENT,
  LINK_NATIVE_CLIENT_FAILURE,
  LINK_NATIVE_CLIENT_SUCCESS,
  LOGIN_REQUEST,
  LOGIN_REQUEST_CANCELLED,
  LOGIN_REQUEST_FAILURE,
  LOGIN_REQUEST_SUCCESS,
  LOGOUT_REQUEST,
  LOGOUT_REQUEST_SUCCESS,
  MFA_OPTION_REQUEST,
  MFA_OPTION_REQUEST_CANCEL,
  MFA_OPTION_REQUEST_FAILURE,
  MFA_OPTION_REQUEST_SUCCESS,
  NATIVE_CLIENTS_REQUEST_FAILURE,
  OAUTH_LOGIN,
  OAUTH_LOGIN_FAILURE,
  OAUTH_LOGIN_SUCCESS,
  OPEN_MODAL,
  OPEN_PIN_DRAWER,
  OPEN_PIN_DRAWER_FAILURE,
  PIN_LOGIN_REQUEST,
  PIN_LOGIN_REQUEST_FAILURE,
  PUT_LANGUAGE_PREFERENCE,
  PUT_LANGUAGE_PREFERENCE_FAILURE,
  PUT_LANGUAGE_PREFERENCE_SUCCESS,
  PUT_PAPERLESS_SETTING,
  PUT_PAPERLESS_SETTING_FAILURE,
  PUT_PAPERLESS_SETTING_SUCCESS,
  REFRESH_MONITOR,
  REFRESH_TOKEN,
  REFRESH_TOKEN_FAILURE,
  RESET_MAIN_ERROR,
  RESET_MAIN_SUCCESS,
  RESET_SSO_MIGRATION,
  RESET_STATUS,
  RESET_SWITCH_LOAN_STATE,
  RESET_USER_STATE,
  SET_CHATBOT_AUTH_TOKEN,
  SET_CHATBOT_WINDOW_STATUS,
  SET_INSTANT_POST_LOGIN_MODAL_STEP,
  SET_IS_CHANGE_SELECTED_LOAN_IN_PROGRESS,
  SET_IS_SSL_AUTH,
  SET_LANGUAGE_PICKER,
  SET_RESPA_FILE,
  SET_SELECTED_LANGUAGE,
  SET_SESSION_STATE,
  SET_SHOULD_RENDER_SPLASH_SCREEN,
  SET_SSO_MIGRATION,
  TOGGLE_RESPA_DRAWER,
  TOTP_CANCEL_REQUEST,
  TOTP_REQUEST,
  TOTP_REQUEST_FAILURE,
  TOTP_REQUEST_SUCCESS,
  UPDATE_DISMISSED_BANNERS,
  UPDATE_DISMISSED_DOC_UPLOAD_BANNERS,
  UPDATE_IS_LOGGED_IN,
  UPDATE_LOANS,
  UPDATE_PRIMARY_LOAN,
  UPDATE_REFRESH_TOKEN,
  UPDATE_SHOULD_BIOMETRICS_OPEN_AUTOMATICALLY,
  UPDATE_SSO_MIGRATION_URL,
  UPDATE_USER_LOANS_DATA,
  UPDATE_USER_PROFILE,
} from './constants';

export function biometricLoginRequest({ shouldResetBanners, ssoClientDetails } = {}) {
  return {
    payload: { shouldResetBanners, ssoClientDetails },
    type: BIOMETRIC_LOGIN_REQUEST,
  };
}

export function biometricLoginRequestFailure(error) {
  return {
    payload: { error },
    type: BIOMETRIC_LOGIN_REQUEST_FAILURE,
  };
}

export function cancelBiometricAuthentication() {
  return { type: CANCEL_BIOMETRIC_AUTHENTICATION };
}

export function cancelChangeSelectedLoan() {
  return { type: CANCEL_CHANGE_SELECTED_LOAN };
}

export function cancelChangeSelectedLoanSuccess() {
  return { type: CANCEL_CHANGE_SELECTED_LOAN_SUCCESS };
}

export function cancelLogin() {
  return { type: CANCEL_LOGIN };
}

export function changeSelectedLoan(loanNumber) {
  return {
    payload: { loanNumber },
    type: CHANGE_SELECTED_LOAN,
  };
}

export function changeSelectedLoanFailure(error) {
  return {
    payload: { error },
    type: CHANGE_SELECTED_LOAN_FAILURE,
  };
}

export function changeSelectedLoanSuccess({
  clientInfo,
  loanDetails,
  selectedLoan,
  selectedLoanLanguagePreference,
  treatments,
}) {
  return {
    payload: {
      clientInfo,
      loanDetails,
      selectedLoan,
      selectedLoanLanguagePreference,
      treatments,
    },
    type: CHANGE_SELECTED_LOAN_SUCCESS,
  };
}

export function closeModal(payload) {
  return {
    payload,
    type: CLOSE_MODAL,
  };
}

export function consentRequest({ consentsAgreed }) {
  return {
    payload: { consentsAgreed },
    type: CONSENT_REQUEST,
  };
}

export function consentRequestFailure({ error }) {
  return {
    payload: { error },
    type: CONSENT_REQUEST_FAILURE,
  };
}

export function consentRequestSuccess() {
  return { type: CONSENT_REQUEST_SUCCESS };
}

export function disableModal(payload) {
  return {
    payload,
    type: DISABLE_MODAL,
  };
}

export function dismissBanner(bannerName) {
  return {
    payload: { bannerName },
    type: ADD_DISMISSED_BANNER,
  };
}
export function dismissDocUploadStatusBanner(documentId) {
  return {
    payload: { documentId },
    type: ADD_DISMISSED_DOC_UPLOAD_BANNER,
  };
}

export function dismissUpdateModal() {
  return { type: DISMISS_UPDATE_MODAL };
}

export function displayChatbotErrorBanner() {
  return { type: DISPLAY_CHATBOT_ERROR_BANNER };
}

export function initializeOidcLogin() {
  return { type: INITIALIZE_OIDC_LOGIN };
}

export function initializeOidcLoginCancelled() {
  return { type: INITIALIZE_OIDC_LOGIN_CANCELLED };
}

export function initializeOidcLoginFailure(error) {
  return {
    payload: { error },
    type: INITIALIZE_OIDC_LOGIN_FAILURE,
  };
}

export function disableInstantPostLoginModal() {
  return { type: DISABLE_INSTANT_POST_LOGIN_MODAL };
}

export function fetchOidcConfig({
  clientId,
  discoveryUrl,
  oidcAuthorizationExtraQueryParams,
  oidcAuthorizationScope,
}) {
  return {
    payload: {
      clientId,
      discoveryUrl,
      oidcAuthorizationExtraQueryParams,
      oidcAuthorizationScope,
    },
    type: FETCH_OIDC_CONFIG,
  };
}

export function fetchOidcConfigFailure(error) {
  return {
    payload: { error },
    type: FETCH_OIDC_CONFIG_FAILURE,
  };
}

export function fetchRespaLetter({ dispatchSetFile, dispatchToggleDrawer, statementId }) {
  return {
    payload: { dispatchSetFile, dispatchToggleDrawer, statementId },
    type: FETCH_RESPA_LETTER,
  };
}

export function fetchRespaLetterFailure(error) {
  return {
    payload: { error },
    type: FETCH_RESPA_LETTER_FAILURE,
  };
}

export function fetchTransferStatus() {
  return { type: FETCH_TRANSFER_STATUS };
}

export function fetchTransferStatusFailure({ error }) {
  return {
    payload: { error },
    type: FETCH_TRANSFER_STATUS_FAILURE,
  };
}

export function fetchTransferStatusSuccess({ servicingTransferDetail }) {
  return {
    payload: { servicingTransferDetail },
    type: FETCH_TRANSFER_STATUS_SUCCESS,
  };
}

export function initializeRequest() {
  return { type: INITIALIZE_REQUEST };
}

export function initializeRequestFailure(error) {
  return {
    payload: { error },
    type: INITIALIZE_REQUEST_FAILURE,
  };
}

export function initializeRequestSuccess({ isLoggedIn } = {}) {
  return {
    payload: { isLoggedIn },
    type: INITIALIZE_REQUEST_SUCCESS,
  };
}

export function linkNativeClient({ clients, lastFourSsn, loanNumber }) {
  return {
    payload: { clients, lastFourSsn, loanNumber },
    type: LINK_NATIVE_CLIENT,
  };
}

export function linkNativeClientFailure({ bannerError, serviceError }) {
  return {
    payload: { bannerError, serviceError },
    type: LINK_NATIVE_CLIENT_FAILURE,
  };
}

export function linkNativeClientSuccess() {
  return { type: LINK_NATIVE_CLIENT_SUCCESS };
}

export function loginRequest({ password, refreshToken, username }) {
  return {
    payload: { password, refreshToken, username },
    type: LOGIN_REQUEST,
  };
}

export function loginRequestCancelled() {
  return { type: LOGIN_REQUEST_CANCELLED };
}

export function loginRequestFailure(errorMessage) {
  return {
    payload: errorMessage,
    type: LOGIN_REQUEST_FAILURE,
  };
}

export function loginRequestSuccess() {
  return { type: LOGIN_REQUEST_SUCCESS };
}

export function logoutRequest(payload = {}) {
  return {
    payload,
    type: LOGOUT_REQUEST,
  };
}

export function logoutRequestSuccess({ message, shouldBiometricsOpenAutomatically }) {
  return {
    payload: { message, shouldBiometricsOpenAutomatically },
    type: LOGOUT_REQUEST_SUCCESS,
  };
}

export function mfaOptionRequest({ mfaOption }) {
  return {
    payload: { mfaOption },
    type: MFA_OPTION_REQUEST,
  };
}

export function mfaOptionRequestCancel() {
  return { type: MFA_OPTION_REQUEST_CANCEL };
}

export function mfaOptionRequestFailure(error) {
  return {
    payload: { error },
    type: MFA_OPTION_REQUEST_FAILURE,
  };
}

export function mfaOptionRequestSuccess() {
  return { type: MFA_OPTION_REQUEST_SUCCESS };
}

export function nativeClientsRequestFailure(error) {
  return {
    payload: { error },
    type: NATIVE_CLIENTS_REQUEST_FAILURE,
  };
}

export function oauthLogin(payload) {
  return {
    payload,
    type: OAUTH_LOGIN,
  };
}

export function oauthLoginFailure(error) {
  return {
    payload: { error },
    type: OAUTH_LOGIN_FAILURE,
  };
}

export function oauthLoginSuccess() {
  return { type: OAUTH_LOGIN_SUCCESS };
}

export function openModal(payload) {
  return {
    payload,
    type: OPEN_MODAL,
  };
}

export function openPinDrawer() {
  return { type: OPEN_PIN_DRAWER };
}

export function openPinDrawerFailure({ error }) {
  return {
    payload: { error },
    type: OPEN_PIN_DRAWER_FAILURE,
  };
}

export function pinLoginRequest({ pin, ssoClientDetails }) {
  return {
    payload: { pin, ssoClientDetails },
    type: PIN_LOGIN_REQUEST,
  };
}

export function pinLoginRequestFailure({ error, isDrawerError }) {
  return {
    payload: { error, isDrawerError },
    type: PIN_LOGIN_REQUEST_FAILURE,
  };
}

export function putLanguagePreference({ languageCode, loanNumber }) {
  return {
    payload: { languageCode, loanNumber },
    type: PUT_LANGUAGE_PREFERENCE,
  };
}

export function putLanguagePreferenceFailure() {
  return { type: PUT_LANGUAGE_PREFERENCE_FAILURE };
}

export function putLanguagePreferenceSuccess() {
  return { type: PUT_LANGUAGE_PREFERENCE_SUCCESS };
}

export function putPaperlessSetting({ loanNumber, requestedOperation }) {
  return {
    payload: { loanNumber, requestedOperation },
    type: PUT_PAPERLESS_SETTING,
  };
}

export function putPaperlessSettingFailure() {
  return { type: PUT_PAPERLESS_SETTING_FAILURE };
}

export function putPaperlessSettingSuccess() {
  return { type: PUT_PAPERLESS_SETTING_SUCCESS };
}

export function refreshMonitor() {
  return { type: REFRESH_MONITOR };
}

export function refreshToken() {
  return { type: REFRESH_TOKEN };
}

export function refreshTokenFailure() {
  return { type: REFRESH_TOKEN_FAILURE };
}

export function resetMainError(prop) {
  return {
    payload: { prop },
    type: RESET_MAIN_ERROR,
  };
}

export function resetMainSuccess() {
  return { type: RESET_MAIN_SUCCESS };
}

export function resetSsoMigration() {
  return { type: RESET_SSO_MIGRATION };
}

export function resetStatus(view) {
  return {
    payload: { view },
    type: RESET_STATUS,
  };
}

export function resetSwitchLoanState() {
  return { type: RESET_SWITCH_LOAN_STATE };
}

export function resetUserState() {
  return { type: RESET_USER_STATE };
}

export function setChatbotAuthToken(chatbotAuthToken) {
  return {
    payload: { chatbotAuthToken },
    type: SET_CHATBOT_AUTH_TOKEN,
  };
}

export function setChatbotWindowStatus(status) {
  return {
    payload: { status },
    type: SET_CHATBOT_WINDOW_STATUS,
  };
}

export function setInstantPostLoginModalStep(step) {
  return {
    payload: { step },
    type: SET_INSTANT_POST_LOGIN_MODAL_STEP,
  };
}

export function setIsChangeSelectedLoanInProgress(value) {
  return {
    payload: { value },
    type: SET_IS_CHANGE_SELECTED_LOAN_IN_PROGRESS,
  };
}

export function setIsSslAuth({ isSslAuth }) {
  return {
    payload: { isSslAuth },
    type: SET_IS_SSL_AUTH,
  };
}

export function setLanguagePicker(language) {
  return {
    payload: { language },
    type: SET_LANGUAGE_PICKER,
  };
}

export function setRespaFile(payload) {
  return {
    payload,
    type: SET_RESPA_FILE,
  };
}

export function setSelectedLanguage(language) {
  return {
    payload: { language },
    type: SET_SELECTED_LANGUAGE,
  };
}

export function setSessionState(sessionState) {
  return {
    payload: { sessionState },
    type: SET_SESSION_STATE,
  };
}

export function setShouldRenderSplashScreen(value) {
  return {
    payload: { value },
    type: SET_SHOULD_RENDER_SPLASH_SCREEN,
  };
}

export function setSsoMigration({
  currentUserEmail,
  migrationImage,
  migrationLoginPage,
  migrationUrl,
}) {
  return {
    payload: {
      currentUserEmail,
      migrationImage,
      migrationLoginPage,
      migrationUrl,
    },
    type: SET_SSO_MIGRATION,
  };
}

export function toggleRespaDrawer(drawerState) {
  return {
    payload: { drawerState },
    type: TOGGLE_RESPA_DRAWER,
  };
}

export function totpCancelRequest() {
  return { type: TOTP_CANCEL_REQUEST };
}

export function totpRequest({ passcode }) {
  return {
    payload: { passcode },
    type: TOTP_REQUEST,
  };
}

export function totpRequestFailure(error) {
  return {
    payload: { error },
    type: TOTP_REQUEST_FAILURE,
  };
}

export function totpRequestSuccess() {
  return { type: TOTP_REQUEST_SUCCESS };
}

export function updateIsLoggedIn({ isLoggedIn, isLoggedOutViaSsoGeneric = false }) {
  return {
    payload: { isLoggedIn, isLoggedOutViaSsoGeneric },
    type: UPDATE_IS_LOGGED_IN,
  };
}

export function updateLoans(loans) {
  return {
    payload: { loans },
    type: UPDATE_LOANS,
  };
}

export function updatePrimaryLoan(loanNumber) {
  return {
    payload: { loanNumber },
    type: UPDATE_PRIMARY_LOAN,
  };
}

export function updateRefreshToken(value) {
  return {
    payload: { value },
    type: UPDATE_REFRESH_TOKEN,
  };
}

export function updateShouldBiometricsOpenAutomatically(shouldBiometricsOpenAutomatically) {
  return {
    payload: { shouldBiometricsOpenAutomatically },
    type: UPDATE_SHOULD_BIOMETRICS_OPEN_AUTOMATICALLY,
  };
}

export function updateUserLoansData(payload) {
  return {
    payload,
    type: UPDATE_USER_LOANS_DATA,
  };
}

export function updateSsoMigrationUrl(payload) {
  return {
    payload,
    type: UPDATE_SSO_MIGRATION_URL,
  };
}

export function updateDismissedBanners(dismissedBanners) {
  return {
    payload: { dismissedBanners },
    type: UPDATE_DISMISSED_BANNERS,
  };
}

export function updateDismissedDocUploadStatusBanners(dismissedDocUploadStatusBanners) {
  return {
    payload: { dismissedDocUploadStatusBanners },
    type: UPDATE_DISMISSED_DOC_UPLOAD_BANNERS,
  };
}

export function updateUserProfile(currentSetting) {
  return {
    payload: { currentSetting },
    type: UPDATE_USER_PROFILE,
  };
}
